export default {
    text: {
        mainPage: {
            newsBlockTitle: 'News',
            newsBlockSubTitle: 'e-enduro small cool text in three lines, from which you want to buy',
            newsBlockSeeAllBtn: 'See all',
            comingSoon: 'Coming Soon',
            showMoreInfoAboutBike: 'Show more',
            buyBikeBtn: 'Buy'
        },
        footer: {
            text: 'If any provision (or part of any provision) of these Terms & Conditions is found to be illegal, invalid or unenforceable under any applicable law, such term shall, insofar as it is severable from the remaining terms, be deemed omitted from this agreement and shall in no way affect the legality, validity or enforceability of the remaining terms.',
            legalLinkText: 'Legal',
            copyright: 'Copyright © 2020 Forestal Group S.L.U. All rights reserved'
        },
        profile: {
            myInfo: {
                title: 'My Info',
                hello: 'Hello',
                keepInfo: 'Please keep the information up to date for better service.',
                firstName: 'First name',
                lastName: 'Last name',
                gender: 'Gender',
                female: 'Female',
                male: 'Male',
                free: 'Non-Binary',
                email: 'Email (login)',
                emailNotVerified: 'Email not verified',
                redensEmailLink: 'Resend verification link',
                mobile: 'Mobile',
                dob: 'Date of birth',
                save: 'Save'
            },
            myBikes: {
                title: 'My Bikes',
                connectedBikes: 'Bikes connected to your account',
                rideTime: 'Total ride time',
                distance: 'Total distance',
                batteryCycles: 'Battery cycles',
                speed: 'Avg speed',
                deleteBike: 'Delete',
                lossMode: 'Loss mode',
                unlinkBike: 'Unlink',
                addNewBike: 'You can add new bike in mobile app',
                downloadApp: 'Download'
            },
            changePassword: {
                title: 'Change Password',
                passwordRule: 'Passwords must contain at least 8 characters, 1 upper case, 1 lower case and 1 numeric.',
                oldPwd: 'Old password',
                newPwd: 'New password',
                repeatPwd: 'New password again',
                save: 'Save'
            },
            orders: {
                title: 'Orders',
                info: 'Summary of your orders and the projected delivery date',
            },
        },
        subscribe: {
            title: 'Subcribe to news',
            enterEmail: 'Enter you e-mail'
        }
    }
};
